import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { PaymentTestModeBanner } from "@/components/PaymentTestModeBanner";
import { StripeEmbeddedCheckout } from "@/components/StripeEmbeddedCheckout";
import { JUGEND_TIER, TIERS, type TierId } from "@/components/PricingTiers";

export const PRICE_BY_TIER: Record<Exclude<TierId, "individuell">, string> = {
  s: "torflash_s_monthly", m: "torflash_m_monthly", l: "torflash_l_monthly", jugend: "torflash_jugend_monthly",
};

export default function CheckoutPage() {
  const navigate = useNavigate();
  const [session, setSession] = useState<{ email?: string } | null>(null);
  const [tier, setTier] = useState<keyof typeof PRICE_BY_TIER | null>(null);
  useEffect(() => {
    supabase.auth.getSession().then(async ({ data }) => {
      const user = data.session?.user;
      if (!user) { navigate("/login"); return; }
      setSession({ email: user.email ?? undefined });
      const { data: club } = await supabase.from("clubs").select("selected_tier").eq("user_id", user.id).maybeSingle();
      if (club?.selected_tier && Object.prototype.hasOwnProperty.call(PRICE_BY_TIER, club.selected_tier)) {
        setTier(club.selected_tier as keyof typeof PRICE_BY_TIER);
      }
    });
  }, [navigate]);
  const info = tier === "jugend" ? JUGEND_TIER : TIERS.find((item) => item.id === tier);
  return <div className="min-h-[calc(100vh-4rem)] bg-background"><PaymentTestModeBanner /><div className="container max-w-2xl py-10">
    <h1 className="font-display text-2xl font-bold text-foreground">Abo abschließen</h1>
    {info && <p className="mt-1 text-sm text-muted-foreground">{info.name}: 14 Tage kostenlos, danach <strong className="text-foreground">{info.monthly} € / Monat</strong>. Monatlich kündbar.</p>}
    <div className="mt-6">{!session ? <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div> : tier ? <StripeEmbeddedCheckout priceId={PRICE_BY_TIER[tier]} customerEmail={session.email} returnUrl={`${window.location.origin}/checkout/return?session_id={CHECKOUT_SESSION_ID}`} /> : <p className="text-sm text-muted-foreground">Kein Paket gewählt. <Link to="/registrieren" className="text-primary underline">Zur Anmeldung</Link></p>}</div>
  </div></div>;
}